module.exports = __webpack_public_path__ + "static/media/PolarisLogo.c7b0d0e4.svg";